<!-- common/export/export-dialog.component.html -->
<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="export-dialog">
  <div class="controls">
    <div class="section-title">Options</div>
      <div class="section-body">
        <mat-form-field appearance="outline" class="filename">
          <mat-label>File name</mat-label>
          <input matInput [(ngModel)]="filename" placeholder="export">
          <mat-hint>.xlsx will be appended</mat-hint>
        </mat-form-field>

        <mat-checkbox [(ngModel)]="applyFilters" (change)="previewChanged()">
          Apply current filters
        </mat-checkbox>

        <mat-checkbox [(ngModel)]="applySort" [disabled]="respectCurrentOrder" (change)="previewChanged()">
          Apply current sort
        </mat-checkbox>

        <mat-checkbox [(ngModel)]="respectCurrentOrder" (change)="previewChanged()">
          Export in current table order (as displayed)
        </mat-checkbox>
      </div>
    </div>

    <!-- COLUMNS section (single list with checkboxes + inline rename + order controls) -->
    <div class="columns">
      <div class="columns-header">
        <div>Columns</div>
        <div class="col-actions">
          <button mat-stroked-button (click)="toggleAll(true)">Select all</button>
          <button mat-stroked-button color="warn" (click)="toggleAll(false)">Clear all</button>
          <button mat-stroked-button (click)="resetToFriendlyNames()">Friendly names</button>
          <button mat-stroked-button (click)="resetNames()">Reset names</button>
        </div>
      </div>

      <div class="columns-list">
        <div class="col-item" *ngFor="let c of columnsForList; trackBy: trackByKey">
          <!-- include/exclude -->
          <mat-checkbox [ngModel]="c.selected"
                        (ngModelChange)="onToggleColumn(c, $event)"
                        [aria-label]="'Toggle ' + c.key">
            <ng-container *ngIf="editingKey !== c.key; else editTpl">
              <span class="header">{{ c.header }}</span>
              <span class="key">({{ c.key }})</span>
            </ng-container>
          </mat-checkbox>

          <!-- inline rename -->
          <ng-template #editTpl>
            <mat-form-field appearance="outline" class="inline-name">
              <mat-label>Header</mat-label>
              <input matInput
                     [(ngModel)]="tempHeader"
                     (keyup.enter)="saveEdit(c)"
                     (keyup.escape)="cancelEdit()"
                     autocomplete="off" />
            </mat-form-field>
          </ng-template>

          <!-- row actions -->
          <div class="row-actions">
            <!-- order controls shown only when selected -->
            <button mat-icon-button
                    [disabled]="!c.selected || orderIndex(c.key) <= 0"
                    (click)="moveSelected(c, -1)"
                    matTooltip="Move up">
              <mat-icon>arrow_upward</mat-icon>
            </button>

            <button mat-icon-button
                    [disabled]="!c.selected || orderIndex(c.key) >= columnOrderKeys.length - 1"
                    (click)="moveSelected(c, +1)"
                    matTooltip="Move down">
              <mat-icon>arrow_downward</mat-icon>
            </button>

            <!-- edit / save / cancel -->
            <button mat-icon-button
                    *ngIf="editingKey !== c.key"
                    (click)="startEdit(c)"
                    matTooltip="Rename column">
              <mat-icon>edit</mat-icon>
            </button>

            <ng-container *ngIf="editingKey === c.key">
              <button mat-icon-button color="primary" (click)="saveEdit(c)" matTooltip="Save">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button (click)="cancelEdit()" matTooltip="Cancel">
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
          </div>
        </div>

        <div class="empty-note" *ngIf="!allColumns?.length">
          <em>No columns detected.</em>
        </div>
      </div>
    </div>




    <div class="preview">
      <div class="section-title">Preview (first 10 rows)</div>
      <div class="section-body">
        <div class="preview-grid">
          <table>
            <thead>
              <tr>
                <th *ngFor="let c of selectedColumns">{{ c.header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filteredPreview">
                <td *ngFor="let c of selectedColumns">
                  {{ (row | jsonForKey: c.key) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="footer-actions" align="end">
  <div class="export-count">
    {{ exportCount | number }} row{{ exportCount === 1 ? '' : 's' }} to export
  </div>
  <span class="spacer"></span>
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary"
          [disabled]="!selectedColumns.length"
          (click)="export()">
    Export
  </button>
</mat-dialog-actions>
